export default function({ store, redirect, route }) {
  store.state.auth.userId == null &&
    route.name !== 'login' &&
    redirect('/login?_next=' + route.path)
  store.state.auth.userId != null && route.name === 'login' && redirect('/')
}
/*
function isAdminRoute(route) {
  if (route.matched.some((record) => record.path === '/admin')) {
    return true
  }
}
*/
